/**
 * Compléments légers pour le menu burger étendu (Empire).
 * - aria-expanded sur le bouton burger
 * - overlay : fermeture optionnelle (le thème ferme toujours par défaut sur clic overlay)
 * - réinitialisation des sous-menus au chargement et au retour navigateur
 */
(function () {
  var nav = document.querySelector('.site-mobile-nav.pbm');
  if (!nav) return;

  var toggle = document.querySelector('button[data-menu-toggle]');
  var overlay = nav.querySelector('[data-mobile-nav-overlay]');
  var submenuToggles = nav.querySelectorAll('[data-pbm-submenu-toggle]');
  var overlayDismiss =
    nav.getAttribute('data-pbm-overlay-dismiss') !== 'false';
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setExpanded(open) {
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function readOpen() {
    return nav.getAttribute('data-open') === 'true';
  }

  setExpanded(readOpen());

  var mo = new MutationObserver(function () {
    setExpanded(readOpen());
  });
  mo.observe(nav, { attributes: true, attributeFilter: ['data-open'] });

  if (overlay && !overlayDismiss) {
    overlay.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );
  }

  function setSubmenuLabel(submenuToggle, open) {
    var nextLabel = open
      ? submenuToggle.getAttribute('data-pbm-submenu-open-label')
      : submenuToggle.getAttribute('data-pbm-submenu-closed-label');

    if (nextLabel) {
      submenuToggle.setAttribute('aria-label', nextLabel);
    }
  }

  function finishSubmenuTransition(submenu, state) {
    submenu.setAttribute('data-pbm-submenu-state', state);
    submenu.style.height = '';
    if (state === 'closed') {
      submenu.hidden = true;
    }
  }

  function openSubmenu(submenuToggle, submenu) {
    submenuToggle.setAttribute('aria-expanded', 'true');
    setSubmenuLabel(submenuToggle, true);
    submenu.hidden = false;

    if (reduceMotion) {
      finishSubmenuTransition(submenu, 'open');
      return;
    }

    submenu.setAttribute('data-pbm-submenu-state', 'closed');
    submenu.style.height = '0px';
    submenu.offsetHeight;

    requestAnimationFrame(function () {
      submenu.setAttribute('data-pbm-submenu-state', 'opening');
      submenu.style.height = submenu.scrollHeight + 'px';
    });

    waitForSubmenuTransition(submenu, function () {
      if (submenuToggle.getAttribute('aria-expanded') === 'true') {
        finishSubmenuTransition(submenu, 'open');
      }
    });
  }

  function closeSubmenu(submenuToggle, submenu) {
    submenuToggle.setAttribute('aria-expanded', 'false');
    setSubmenuLabel(submenuToggle, false);

    if (reduceMotion) {
      finishSubmenuTransition(submenu, 'closed');
      return;
    }

    submenu.hidden = false;
    submenu.style.height = submenu.getBoundingClientRect().height + 'px';
    submenu.setAttribute('data-pbm-submenu-state', 'closing');
    submenu.offsetHeight;

    requestAnimationFrame(function () {
      submenu.style.height = '0px';
    });

    waitForSubmenuTransition(submenu, function () {
      if (submenuToggle.getAttribute('aria-expanded') === 'false') {
        finishSubmenuTransition(submenu, 'closed');
      }
    });
  }

  function waitForSubmenuTransition(submenu, callback) {
    var done = false;
    var fallback = window.setTimeout(complete, 360);

    function complete() {
      if (done) return;
      done = true;
      window.clearTimeout(fallback);
      submenu.removeEventListener('transitionend', onTransitionEnd);
      callback();
    }

    function onTransitionEnd(event) {
      if (event.target === submenu && event.propertyName === 'height') {
        complete();
      }
    }

    submenu.addEventListener('transitionend', onTransitionEnd);
  }

  function resetSubmenu(submenuToggle) {
    var submenuId = submenuToggle.getAttribute('aria-controls');
    var submenu = submenuId ? document.getElementById(submenuId) : null;

    if (!submenu) return;

    submenuToggle.setAttribute('aria-expanded', 'false');
    setSubmenuLabel(submenuToggle, false);
    finishSubmenuTransition(submenu, 'closed');
  }

  function resetAllSubmenus() {
    Array.prototype.forEach.call(submenuToggles, resetSubmenu);
  }

  Array.prototype.forEach.call(submenuToggles, function (submenuToggle) {
    submenuToggle.addEventListener('click', function () {
      var submenuId = submenuToggle.getAttribute('aria-controls');
      var submenu = submenuId ? document.getElementById(submenuId) : null;
      var isOpen = submenuToggle.getAttribute('aria-expanded') === 'true';

      if (!submenu) return;

      if (isOpen) {
        closeSubmenu(submenuToggle, submenu);
      } else {
        openSubmenu(submenuToggle, submenu);
      }
    });
  });

  var parentLinks = nav.querySelectorAll('[data-pbm-parent-link]');
  Array.prototype.forEach.call(parentLinks, function (parentLink) {
    parentLink.addEventListener('click', function (e) {
      e.preventDefault();
      var submenuId = parentLink.getAttribute('aria-controls');
      var submenuToggle = submenuId
        ? nav.querySelector('[data-pbm-submenu-toggle][aria-controls="' + submenuId + '"]')
        : null;
      if (submenuToggle) submenuToggle.click();
    });
  });

  resetAllSubmenus();
  window.addEventListener('pageshow', function () {
    setExpanded(readOpen());
    resetAllSubmenus();
  });
})();
